/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M12 0a.75.75 0 0 1 .75.75v15.4393l6.2197-6.2196a.75.75 0 1 1 1.0606 1.0606L12 19.0607l-8.0303-8.0304a.75.75 0 1 1 1.0606-1.0606l6.2197 6.2196V.75A.75.75 0 0 1 12 0ZM1.5 20.25a.75.75 0 0 1 .75.75c0 .8284.6716 1.5 1.5 1.5h16.5c.8284 0 1.5-.6716 1.5-1.5a.75.75 0 0 1 1.5 0c0 1.6569-1.3431 3-3 3H3.75c-1.6568 0-3-1.3431-3-3a.75.75 0 0 1 .75-.75Z"
    clipRule="evenodd"
  />,
  'Download'
);
